export const TERMS_OF_SERVICE = `
TERMS OF SERVICE - SFarm Monitor

Last Updated: February 8, 2026

1. ACCEPTANCE OF TERMS
By registering for and using SFarm Monitor ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use the Service.

2. SERVICE DESCRIPTION
SFarm Monitor provides agricultural monitoring services including:
- Weather monitoring and forecasts
- Crop growth tracking (GDD)
- Disease and pest pressure alerts
- NDVI vegetation monitoring
- Field management tools
- AI-powered crop health assistance

3. SUBSCRIPTION & PAYMENT
3.1 Free Trial: New users receive a 30-day free trial
3.2 Paid Plans:
    - Monthly: $27.99/month
    - Yearly: $279.90/year (10 months pricing)
3.3 Payment is processed via Stripe
3.4 Subscriptions auto-renew unless cancelled
3.5 Refunds are at our sole discretion

4. USER OBLIGATIONS
You agree to:
- Provide accurate farm and field information
- Use the Service for lawful agricultural purposes only
- Not share your account credentials
- Not attempt to reverse engineer or compromise the Service
- Maintain the security of your account

5. DATA & PRIVACY
5.1 We collect: farm locations, field data, weather readings, user interactions
5.2 We use data to: provide monitoring services, generate alerts, improve the Service
5.3 We DO NOT sell your data to third parties
5.4 We use third-party services: Tomorrow.io (weather), ESA Copernicus Sentinel Hub (NDVI), Google Maps (mapping), Firebase (notifications), OpenAI (AI chat)
5.5 You retain ownership of your farm and field data
5.6 You can request data deletion at any time

6. ACCURACY & LIABILITY
6.1 Weather data and forecasts are provided by third-party services
6.2 Disease/pest alerts are informational guidance only
6.3 YOU ARE RESPONSIBLE for making final agricultural decisions
6.4 We are NOT LIABLE for:
    - Crop losses or failures
    - Inaccurate weather forecasts
    - Missed alerts or notifications
    - Service interruptions or downtime
    - Third-party service failures
6.5 Service is provided "AS IS" without warranties

7. LIMITATIONS OF LIABILITY
TO THE MAXIMUM EXTENT PERMITTED BY LAW:
- Our liability is limited to the amount you paid in the last 12 months
- We are not liable for indirect, incidental, or consequential damages
- We are not liable for agricultural losses, crop failures, or business interruption

8. INTELLECTUAL PROPERTY
8.1 The Service, software, and content are owned by SFarm Monitor
8.2 You receive a limited license to use the Service
8.3 You may not copy, modify, or distribute our software
8.4 Crop monitoring algorithms and disease models are proprietary

9. API USAGE & LIMITS
9.1 AI Chat limited to 20 messages per user per day
9.2 Weather data updated twice daily (8 AM, 8 PM)
9.3 Excessive API usage may result in account suspension

10. TERMINATION
10.1 You can cancel your subscription at any time
10.2 We may terminate accounts for Terms violations
10.3 Upon termination, you lose access to the Service
10.4 We may retain data for legal/backup purposes

11. CHANGES TO TERMS
11.1 We may update these Terms at any time
11.2 Continued use after changes constitutes acceptance
11.3 Material changes will be notified via email or in-app

12. AGRICULTURAL ADVICE DISCLAIMER
- Alerts and recommendations are GUIDANCE ONLY
- Always consult with agronomists and local experts
- Consider local regulations for pesticide/fertilizer use
- We are not liable for treatment decisions you make
- Scout fields personally before taking action

13. THIRD-PARTY SERVICES
We integrate with:
- Tomorrow.io (weather) - subject to their terms
- ESA Copernicus Sentinel Hub (NDVI satellite imagery) - subject to their terms
- Google Maps (mapping) - subject to their terms
- Firebase (notifications) - subject to Google's terms
- OpenAI (AI chat) - subject to their terms
- Stripe (payments) - subject to their terms

14. GOVERNING LAW
These Terms are governed by the laws of [YOUR JURISDICTION]

15. DISPUTE RESOLUTION
Any disputes will be resolved through binding arbitration

16. CONTACT
For support or questions: support@sfarmmonitor.com

17. SEVERABILITY
If any provision is invalid, the remaining provisions remain in effect

18. ENTIRE AGREEMENT
These Terms constitute the entire agreement between you and SFarm Monitor

BY CLICKING "I AGREE" OR USING THE SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS.
`;

export const PRIVACY_POLICY = `
PRIVACY POLICY - SFarm Monitor

Your privacy is important to us. This policy explains how we collect, use, and protect your data.

DATA WE COLLECT:
- Account: Email, password (encrypted)
- Farm: Name, location coordinates
- Fields: Boundaries, crop types, sowing/harvest dates
- Weather: Historical readings for your farm
- Usage: AI chat messages, feature usage

HOW WE USE DATA:
- Provide monitoring and alert services
- Calculate GDD and crop stages
- Generate disease/pest recommendations
- Improve our algorithms and Service

DATA SHARING:
- We DO NOT sell your data
- Third-party services access data as needed to provide features
- We may share aggregated anonymous data for research

DATA SECURITY:
- All data encrypted in transit (HTTPS)
- Database access restricted
- API keys and passwords encrypted
- Regular security audits

YOUR RIGHTS:
- Access your data at any time
- Request data export
- Request data deletion
- Opt out of non-essential communications

CONTACT: privacy@sfarmmonitor.com
`;
